import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "time" }
const _hoisted_2 = { class: "time-fix hide-print" }
const _hoisted_3 = { class: "time" }

import { PropType } from 'vue'

type Row = {
  time: string
  values: (string | undefined)[]
}


export default /*#__PURE__*/_defineComponent({
  props: {
  rows: {
    type: Array as PropType<Row[]>,
    default: () => [],
  },
  style: {
    type: String,
    default: '',
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("table", {
      style: _normalizeStyle(__props.style)
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.rows, (row, index) => {
        return (_openBlock(), _createElementBlock("tr", { key: index }, [
          _createElementVNode("td", _hoisted_1, _toDisplayString(row.time === '00:00' ? '24:00' : row.time), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.values, (value, index) => {
            return (_openBlock(), _createElementBlock("td", { key: index }, _toDisplayString(value), 1))
          }), 128))
        ]))
      }), 128))
    ], 4),
    _createElementVNode("table", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.rows, (row, index) => {
        return (_openBlock(), _createElementBlock("tr", { key: index }, [
          _createElementVNode("td", _hoisted_3, _toDisplayString(row.time === '00:00' ? '24:00' : row.time), 1)
        ]))
      }), 128))
    ])
  ]))
}
}

})